import axios from 'axios';
import _ from 'lodash';
import { toJS, makeAutoObservable, runInAction, reaction } from 'mobx';
import { getUrlParam } from '../utils/url.utils';
import { conditionConstants } from '../constants/condition.constants';
import { defaultInvoiceFields } from '../constants/invoiceFields.constants';
import { conditionTranslator, conditionNavigator } from '../utils/condition.utils';
import { HotelStore } from '../stores/hotel/HotelStore';
import { validateOrgno } from '../utils/validation.utils';

const API_KEY_WEBFONTS = 'AIzaSyB6aQW4uFg8OuFMHaxBmqDPCvzBGe5vuTg';

const patch = !window?.location?.host?.includes('localhost') ? '/cview' : '';

const axiosClient = axios.create({
  baseURL: `${window.location.protocol}//${window.location.host}${patch}/api`,
});

export const basedAxios = axiosClient;

const cache = {};

var updateSqlStateTimeout;

class ContentViewStore {
  constructor() {
    makeAutoObservable(this);
  }
  form = null;
  path = '/cms';
  setPath = p => {
    runInAction(() => {
      this.path = p;
    });
  };

  setForm = id => {
    if (!id) return;
    let parsed = id.split('/').filter(x => x !== 'cms' && x !== 'web' && x !== '');
    if (!parsed || parsed.length !== 1) return;
    parsed = parsed[0];
  };

  current = {
    selectedModule: null,
    activeLayout: null,
    activePage: 1,
    versionIndex: 0,
    template: {},
    payMethod: '',
    hasContentView: false,
    scopedLayout: null,
  };

  environment = {
    eventId: null,
    currency: 'SEK',
    name: '',
    lang: 'swe',
    eventCountry: 'SWE',
    defaultCountry: null,
    countryGroup: '1',
  };
  countries = [];
  axiosClient = undefined;

  contentLayout = {};
  contentHeaderLayout = {};
  contentFooterLayout = {};
  modules = [];
  layoutCode = null;

  hasFetched = false;
  fetching = false;
  lastFetch = null;

  questions = [];

  breakouts = [];

  fields = [];

  mainEvent = null;
  printable = false;
  googleFonts = [];
  uploadedFonts = [];
  clientFontsLoaded = false;
  googleFontsLoaded = false;
  fontAppended = false;
  mainEventFullbooked = false;
  mainEventDeadlinePassed = false;

  ordersLoaded = false;
  orders = [];
  sqlStateNo = null;
  activePersonNo = 0;
  notAuthorized = false;
  showPwdDialog = false;

  event = {};
  breakoutsFullbooked = {};
  voucherFullbooked = {};

  displayConfirmationSettings = [];
  displayEventSettings = [];
  xrayMode = false;

  userInteracted = false;

  validations = [];
  validate = false;

  voucherList = [];

  conditions = {};

  showPageClosed = false;

  hotelStore = new HotelStore(this);

  eventLabels = {};
  systemLabels = [];

  showPwdDialog = false;

  menuItems = [];

  fetchData = async (layoutCode, prevState) => {
    if (this.fetching) return;
    if (this.hasFetched && this.lastFetch == layoutCode) return;
    this.fetching = true;

    axiosClient
      .get(`./cms/${layoutCode}/?newSqlStateNo=${prevState}`)
      .then(async ({ data }) => {
        runInAction(async () => {
          this.lastFetch = layoutCode;

          this.environment.eventId = data.contentLayout.eventId;
          this.environment.currency = data.currency || 'SEK';

          this.contentLayout = data.contentLayout;
          this.contentHeaderLayout = data.contentHeaderLayout;
          this.contentFooterLayout = data.contentFooterLayout;
          this.modules = data.contentModules;
          this.questions = data.questions;
          this.breakouts = data.breakouts;
          this.environment.eventCountry = data.eventCountry;
          this.environment.countryGroup = data.countryGroup;
          this.sqlStateNo = data.sqlStateNo;
          this.mainEvent = data.mainEvent;
          this.printable = data.contentLayout.printable;
          this.current.activePage = 1;
          if (this.contentLayout.conditions) {
            this.contentLayout.conditions = JSON.parse(this.contentLayout.conditions);
          }

          this.contentLayout.contentLayoutModules = this.contentLayout.contentLayoutModules.map(clm => {
            clm.conditions = JSON.parse(clm.conditions);
            return clm;
          });

          this.current.hasContentView = this.contentLayout.contentLayoutModules.find(clm => clm.contentModule.type == 'CONTENT_VIEW');

          const displayEventSettings = {};
          data.displayEventSettings.forEach(de => {
            displayEventSettings[de.name] = de.value;
          });
          this.displayEventSettings = displayEventSettings;

          const displayConfirmationSettings = {};
          data.displayConfirmationSettings.forEach(de => {
            displayConfirmationSettings[de.name] = de.value;
          });
          this.displayConfirmationSettings = displayConfirmationSettings;

          this.fields = data.fields;
          this.current.template = data.templates.find(t => t.templateId == data.contentLayout.templateId);
          this.hasFetched = true;

          const badgeNo = getUrlParam('badgeno') ?? getUrlParam('clientkey');

          const xrayMode = getUrlParam('xray');

          this.xrayMode = xrayMode;
          this.configureEnvironment(data.contentLayout, data);

          if (badgeNo) {
            this.getAttendee(badgeNo, layoutCode);
          } else {
            if (this.orders.length > 0) {
              this.orders = [];
            }
            this.createOrder();
            this.ordersLoaded = true;
          }

          if (this.contentLayout?.groupLeaderChangeLock) {
            var o = this.orders.find(x => x.badgeNo == badgeNo);
            if (o && o.orderGroupId && o.orderGroupId !== o.orderId) {
              this.notAuthorized = true;
            }
          }

          // Only check for deadline if no badgeNo is provided (new order)
          if (!badgeNo && this.contentLayout?.type === 'FORM') {
            this.checkForMainEventDeadline();
          }

          if (this.contentLayout.googleAnalytics) {
            this.appendGoogleAnalytics(this.contentLayout.googleAnalytics);
          }
          if (this.contentLayout.facebookPixel) {
            this.appendFacebookPixel(this.contentLayout.facebookPixel);
          }
          if (this.contentLayout.documentTitle) {
            document.title = this.contentLayout.documentTitle;
          } else if (this.mainEvent && this.mainEvent.name) {
            document.title = this.mainEvent.name;
          }
          if (this.contentLayout.faviconUrl) {
            //hardcoded, fix
            this.setPageIcon(this.contentLayout.faviconUrl);
          }

          if (
            (data.contentLayout.openDateTime && +new Date(data.contentLayout.openDateTime) > Date.now()) ||
            (data.contentLayout.closeDateTime && +new Date(data.contentLayout.closeDateTime) < Date.now())
          ) {
            if (data.contentLayout?.redirectUrl) {
              window.location.href = data.contentLayout?.redirectUrl;
            } else {
              this.showPageClosed = true;
            }
          }

          if (data.contentLayout.password) {
            let pwdItem = localStorage.getItem(`pwd_${this.contentLayout.contentLayoutId}`);
            if (!pwdItem || atob(pwdItem) != data.contentLayout.password) {
              this.showPwdDialog = true;
            }
          }
          this.getCountries();
          this.getEventLanguages();
          const isChangeLink = badgeNo;

          if (data.contentLayout.type == 'FORM' && !isChangeLink) {
            await this.checkMainEventBookingStatus();
          } else if (data.contentLayout.type == 'SURVEY') this.checkIsSurveyAnswered(layoutCode, badgeNo);

          if (
            this.checkFontStyles(this.current.template?.formattedCss) ||
            this.checkFontStyles(this.contentLayout?.css) ||
            this.checkFontStyles(this.contentHeaderLayout?.css) ||
            this.checkFontStyles(this.contentFooterLayout?.css)
          ) {
            await this.handleFonts(this.current.template, this.contentLayout, this.contentHeaderLayout, this.contentFooterLayout);
          }
        });
      })
      .catch(err => {
        console.error(err);
        if (err?.response?.status === 404) {
          window.location = window.location.origin;
        }
      })
      .finally(() => {
        this.fetching = false;
      });
  };

  setUserInteracted = val => {
    runInAction(() => {
      this.userInteracted = val;
    });
  };

  checkFontStyles = css => {
    if (!css) return false;

    const importRegex = /@import url\([\s\S]*?\);/gi;
    const fontFaceRegex = /@font-face {[\s\S]*?}/gi;
    const fontNameRegex = /font-family:["'\s]{0,1}(.*?)["'\s]{0,1};/gi;
    let fontName = null;

    if (css.match(importRegex)?.length > 0 || css.match(fontFaceRegex)?.length > 0) return false;
    // let fontName = fontNameRegex.exec(css)
    const SYSTEM_FONTS = [
      'Arial',
      'Helvetica',
      'Times New Roman',
      'Times',
      'Courier New',
      'Courier',
      'Verdana',
      'Georgia',
      'Comic Sans MS',
      'Trebuchet MS',
      'Arial Black',
      'Impact',
    ];
    while (null != (fontName = fontNameRegex.exec(css))) {
      if (SYSTEM_FONTS.includes(fontName[1])) continue;
      else return true;
    }
    return false;
  };

  handleFonts = async (template, contentLayout, header, footer) => {
    await this.fetchGoogleFonts();
    await this.fetchClientFonts();

    const templateFonts = this.addOrUpdateFont(template.formattedCss);
    if (templateFonts) {
      runInAction(() => {
        template.formattedCss = templateFonts + template.formattedCss;
      });
      axiosClient.put(`./utility/template/${template.templateId}`, templateFonts, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    const contentFonts = this.addOrUpdateFont(contentLayout.css);
    if (contentFonts) {
      runInAction(() => {
        contentLayout.css = contentFonts + contentLayout.css;
      });
      axiosClient.put(`./utility/contentLayout/${contentLayout.contentLayoutId}`, contentFonts, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    const headerFonts = this.addOrUpdateFont(header?.css);
    if (headerFonts) {
      runInAction(() => {
        header.css = headerFonts + header.css;
      });
      axiosClient.put(`./utility/contentLayout/${header.contentLayoutId}`, headerFonts, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
    const footerFonts = this.addOrUpdateFont(footer?.css);
    if (footerFonts) {
      runInAction(() => {
        footer.css = footerFonts + footer.css;
      });
      axiosClient.put(`./utility/contentLayout/${footer.contentLayoutId}`, footerFonts, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
    }
  };

  getCountries = () => {
    axiosClient.get(`./country/`).then(({ data }) => {
      runInAction(() => {
        this.countries = data;
      });
    });
  };

  setMenuItems = items => {
    if (items !== '' && items !== undefined && items !== null) {
      runInAction(() => {
        this.menuItems = items;
      });
    }
  };

  setPageIcon = url => {
    let link = document.querySelector('link[rel=icon]');
    if (!link) {
      link = document.createElement('link');
      link.id = 'favicon';
      link.rel = 'icon';
      document.head.append(link);
    }
    link.href = url + '?=' + Math.random();
  };

  getEventLanguages = () => {
    axiosClient.get(`./language/${this.environment.eventId}`).then(res => {
      const eventLanguages = res.data;
      runInAction(() => {
        this.event.languages = eventLanguages;
      });
    });
  };

  getAttendee = async (badgeNo, code) => {
    try {
      const res = await axiosClient.get(`./attendee/${badgeNo}?layoutCode=${code}`);
      runInAction(() => {
        const { data } = res;
        if (Array.isArray(data)) {
          this.orders = data;
          this.ordersLoaded = true;
          this.activePersonNo = 0;
          this.checkConditionsOld();
          this.checkConditions();
        } else {
          this.notAuthorized = true;
        }
      });
    } catch (error) {
      console.error(error);
    } finally {
      this.ordersLoaded = true;
    }
  };

  //#region FONTS

  fetchGoogleFonts = async () => {
    if (!this.googleFontsLoaded) {
      try {
        const { data } = await axios.get(`https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=${API_KEY_WEBFONTS}`);
        const googleFonts = _.sortBy(data.items, item => item.family).map(({ family }) => family);
        this.googleFonts = googleFonts;
        this.googleFontsLoaded = true;
        return googleFonts;
      } catch (error) {
        console.error(error);
        this.googleFontsLoaded = false;
        return [];
      }
    }
  };

  fetchClientFonts = async () => {
    function cleanedName(name) {
      return name
        .substring(name.lastIndexOf('/') + 1, name.lastIndexOf('.') + 1)
        .toString()
        .replace(')', '')
        .replace('(', '')
        .replace('.', '')
        .replace('1', '')
        .replace('', '');
    }
    if (!this.clientFontsLoaded) {
      try {
        const { data } = await axiosClient.get(`./files/fonts/${this.environment.eventId}`);
        const uploadedFonts = data.files.map(({ url, name }) => ({
          name: cleanedName(name),
          url,
        }));
        this.uploadedFonts = uploadedFonts;
        this.clientFontsLoaded = true;
        return uploadedFonts;
      } catch (error) {
        console.error(error);
        this.clientFontsLoaded = false;
        return [];
      }
    }
  };

  addOrUpdateFont = css => {
    if (!css) return null;
    const { googleFonts, uploadedFonts } = this;
    const fontFamilies = css.match(/font-family:\s*([^;]+);/g);

    if (fontFamilies) {
      const extractedFonts = fontFamilies.map(fontFamily => fontFamily.match(/font-family:\s*([^;]+);/)[1].trim());

      const googleFontsV1 = ['Source Sans Pro'];

      const categorizedFonts = extractedFonts.reduce((acc, font) => {
        if (googleFonts.find(f => f === font) || googleFontsV1.includes(font)) {
          acc.push({ font, type: 'GOOGLE' });
        } else if (uploadedFonts.find(f => f.name === font)) {
          acc.push({
            font,
            type: 'UPLOADED',
            url: uploadedFonts.find(f => f.name === font).url,
          });
        }
        return acc;
      }, []);

      const fontsString = categorizedFonts.reduce((acc, f) => {
        if (f.type === 'GOOGLE') {
          const ff = this.createImport(f.font).replace('https: //', 'https://');
          if (!css.includes(ff) && !acc.includes(ff)) acc += ff + '\r\n';
        } else {
          const ff = this.createFontFace(f);
          if (!css.includes(ff) && !acc.includes(ff)) acc += ff + '\r\n';
        }
        return acc;
      }, '');

      return fontsString;
    }
    return '';
  };

  createFontFace = ({ url, font }) => {
    return `@font-face { font-family: ${font}; src: url('${url}'); }`;
  };

  createImport = font => {
    return `@import url("https://fonts.googleapis.com/css2?family=${font
      .replace(/\s/g, '+')
      .replace(
        '-',
        '+'
      )}:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");`;
  };
  //#endregion FONTS

  appendGoogleAnalytics = googleAnalyticsId => {
    var script1 = document.createElement('script');
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsId.replace(' ', '')}`;
    script1.async = true;
    document.head.appendChild(script1);

    var script2 = document.createElement('script');
    script2.text = `window.dataLayer = window.dataLayer || [];
                            function gtag(){dataLayer.push(arguments);}
                            gtag('js', new Date());
                            gtag('config', '${googleAnalyticsId.replace(' ', '')}');`;

    document.head.appendChild(script2);
  };

  appendFonts = fontStyles => {
    // const style = document.createElement('style');
    // style.id = 'fontStyles';
    // style.innerHTML = fontStyles;
    // document.head.appendChild(style);
  };

  appendFacebookPixel = facebookPixelId => {
    var script2 = document.createElement('script');
    script2.text = `
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '${facebookPixelId.replace(' ', '')}');
  fbq('track', 'PageView');
  `;
    document.head.appendChild(script2);
  };

  checkForMainEventDeadline = async () => {
    try {
      const response = await axiosClient.get(`./event/deadline/${this.mainEvent.eventId}`);
      const passed = response?.data?.passed || false;
      this.mainEventDeadlinePassed = passed;
    } catch (error) {
      console.error(error);
    }
  };

  checkMainEventBookingStatus = async () => {
    try {
      const response = await axiosClient.get(`./attendee/status/${this.mainEvent.eventId}?sqlStateNo=${this.sqlStateNo}`);
      const available = response?.data?.available || false;
      this.mainEventFullbooked = !available;
      return available;
    } catch (error) {
      console.error(error);
      return false;
    }
  };

  configureEnvironment = (layout, res) => {
    const lang = getUrlParam('lang');
    if (lang) {
      this.environment.lang = lang;
    } else {
      this.environment.lang = res.defaultLanguage;
    }

    if (res?.defaultSelectedCountry) {
      this.environment.defaultCountry = parseInt(res?.defaultSelectedCountry);
    }

    if (layout.type == 'FORM') {
      this.environment.name = 'FORM';
      this.sqlStateNo = res.sqlStateNo;
      this.configureValidation();
      this.checkConditionsOld();
      this.checkConditions();
    } else if (layout.type == 'SURVEY') {
      this.environment.name = 'SURVEY';
      this.sqlStateNo = res.sqlStateNo;
      this.configureValidation();
      this.checkConditionsOld();
      this.checkConditions();
    }
  };

  checkInvoiceValidation = isValid => {
    if (
      this.validations
        .filter(v => v.page == this.current.activePage)
        .find(
          v =>
            v.id.toString().includes('INVOICE_') &&
            this.current.payMethod != 'invoice' &&
            this.current.payMethod != 'dibs' &&
            this.current.payMethod != 'stripe' &&
            this.validatePaymentFields
        )
    ) {
      isValid = this.getFilteredValidations().length === 0;
    } else if (
      this.validations
        .filter(v => v.page === this.current.activePage)
        .find(v => (v.id.toString().includes('INVOICE_') && this.current.payMethod != 'invoice') || !this.validatePaymentFields)
    ) {
      isValid = this.getFilteredValidations().length === 0;
    }
    return isValid;
  };

  getFilteredValidations = () => {
    const currentPageValidations = this.validations.filter(v => v.page == this.current.activePage || v.page === 0);
    //if any id of any validations is an invoice field (aka includes INVOICE_), AND if current payMethod isn't invoice nor dibs, AND we're suppossed to validate fields
    if (
      currentPageValidations.find(v => v.id.toString().includes('INVOICE_')) &&
      !['invoice', 'dibs', 'stripe'].includes(this.current.payMethod) &&
      this.validatePaymentFields
    ) {
      //return any current page validation that is invalid, visible, and not invoice
      return currentPageValidations.filter(v => v.valid == false && !this.isHiddenByConditions(v.id) && !v.id.toString().includes('INVOICE_') && !v.hidden);
    }
    //if (any id of the validations is an invoice field (aka includes INVOICE_), AND if current payMethod isn't invoice), OR we're not supposed to validate payment fields
    else if (currentPageValidations.find(v => (v.id.toString().includes('INVOICE_') && this.current.payMethod != 'invoice') || !this.validatePaymentFields)) {
      //return any current page validation that is invalid, visible, and not invoice

      return currentPageValidations.filter(v => {
        if (v.valid === false && !this.isHiddenByConditions(v.id)) {
          if (v.id.toString().includes('INVOICE_') && v.forced) {
            return true;
          } else if (!v.id.toString().includes('INVOICE_') && v.label != 'PaymentOption' && !v.hidden) {
            return true;
          }
        }
      });
    } else {
      return currentPageValidations.filter(v => v.valid == false && !this.isHiddenByConditions(v.id) && !v.hidden);
    }
  };

  configureValidation = () => {
    var oldValidations = _.cloneDeep(this.validations);

    this.validations = [];
    const layout = this.current.scopedLayout ? this.current.scopedLayout : this.contentLayout;
    layout?.contentLayoutModules.map(clm => {
      const validationObject = { page: clm.pages, valid: false, id: clm.contentModule.contentModuleId, reason: '' };

      if (clm.contentModule.type == 'FIELD' || clm.contentModule.type == 'QUESTION') {
        if (
          clm.contentModule.settings.required ||
          (clm.contentModule.settings.fieldType &&
            (clm.contentModule.settings.fieldType.toLowerCase() == 'email' ||
              clm.contentModule.settings.fieldType.toLowerCase() == 'firstname' ||
              clm.contentModule.settings.fieldType.toLowerCase() == 'lastname'))
        ) {
          validationObject.reason = 'required';
          if (clm.contentModule.settings?.fieldType && clm.contentModule.settings?.type?.toLowerCase() === 'person') {
            validationObject.decorator = clm.contentModule.settings.fieldType.toLowerCase();
          }
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      } else if (clm.contentModule.type == 'EVENT' || clm.contentModule.type == 'EVENT_GROUP') {
        if (clm.contentModule.settings.required && !clm.contentModule.settings.prechecked) {
          validationObject.reason = 'required';
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      } else if (clm.contentModule.type == 'CONFIRM_MEETING') {
        if (clm.contentModule.settings.required) {
          validationObject.reason = 'required';
          validationObject.decorator = 'confirmmeeting';
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      }
  
      if (clm.contentModule.type == 'CUSTOMFIELD') {
        if (clm.contentModule.settings.required) {
          validationObject.reason = 'required';
          validationObject.decorator = 'customfield' + clm.contentModule.settings.type.toLowerCase();
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      }
      if (clm.contentModule.type == 'PAYMENT_OPTIONS' && clm.contentModule.settings.paymentMethods.includes('invoice')) {
        defaultInvoiceFields.map(df => {
          let defaultValidity = false;
          switch (df) {
            case 'Email':
            case 'Telephone1':
            case 'Address2':
            case 'GLN':
              defaultValidity = true;
              break;
            default:
              defaultValidity = false;
              break;
          }
          this.validations.push({ page: clm.pages, valid: defaultValidity, id: `INVOICE_${df}`, label: df + 'ValidationMessage', type: df });
        });
        if (clm.contentModule.settings.paymentMethods.length > 1) {
          this.validations.push({
            page: clm.pages,
            valid: true,
            id: clm.contentModule.contentModuleId,
            label: 'PaymentOption',
            message: 'PaymentOptionValidationMessage',
          });
        }
      }

      if (clm.contentModule.type == 'PAYMENT_OPTIONS_TWO') {
        defaultInvoiceFields.map(df => {
          let defaultValidity = false;

          let currentValidity = oldValidations.find(v => v.id == `INVOICE_${df}`);
          if (currentValidity != undefined) {
            currentValidity = currentValidity.valid;
          }
          switch (df) {
            case 'Email':
            case 'Address1':
            case 'Address2':
            case 'GLN':
              defaultValidity = true;
              break;
            default:
              defaultValidity = false;
              break;
          }
          this.validations.push({
            page: clm.pages,
            valid: currentValidity ? currentValidity : defaultValidity,
            id: `INVOICE_${df}`,
            label: df + 'ValidationMessage',
            type: df,
          });
        });
        if (clm.contentModule.settings.paymentMethods.length > 1) {
          this.validations.push({
            page: clm.pages,
            valid: true,
            id: clm.contentModule.contentModuleId,
            label: 'PaymentOption',
            message: 'PaymentOptionValidationMessage',
          });
        }
      }
      if (clm.contentModule.type == 'PROFILEIMAGE_UPLOADER') {
        if (clm.contentModule.settings.required) {
          validationObject.reason = 'required';
          validationObject.decorator = 'PROFILEIMAGE_UPLOADER';
        } else {
          validationObject.valid = true;
        }
        this.validations.push(validationObject);
      }
      if (clm.conditions && typeof clm.conditions == 'string' && clm.conditions != 'null') {
        clm.conditions = JSON.parse(clm.conditions);
      }
      if (!this.conditions[clm.contentLayoutModuleId]) this.conditions[clm.contentLayoutModuleId] = { hidden: false, readonly: false, required: false };
      // this.checkConditionsOld(clm.contentLayoutModuleId);
      // this.checkConditions()
    });

    const hasAllDecorators =
      this.validations.filter(
        v => v?.decorator?.toLowerCase() == 'email' || v?.decorator?.toLowerCase() == 'firstname' || v?.decorator?.toLowerCase() == 'lastname'
      ).length !== 3;

    if (hasAllDecorators && this.environment.name === 'FORM' && !this.orders?.[0]?.badgeNo) {
      const mustIncludeValidationObjects = [
        { decorator: 'email', reason: 'required', id: 0, valid: false, page: 0 },
        { decorator: 'firstname', reason: 'required', id: 0, valid: false, page: 0 },
        { decorator: 'lastname', reason: 'required', id: 0, valid: false, page: 0 },
      ];

      mustIncludeValidationObjects?.forEach(v => {
        if (this.validations?.find(x => x.decorator === v.decorator)) return;
        this.validations.push(v);
      });
    }
  };

  replaceTags = async textContent => {
    //this.orders.length > 0 && this.orders[this.activePersonNo]?.orderId &&
    if (textContent && /\[.*\]/.test(textContent)) {
      var response = await axiosClient.put(`./tag/tagreplace`, {
        text: textContent,
        orderId: toJS(this.orders)?.[this.activePersonNo]?.orderId ?? 0,
        eventId: this.environment.eventId,
        lang: this.environment.lang,
      });
      return response.data.text;
    } else {
      return textContent;
    }
  };

  isHiddenByConditions = id => {
    var hidden = false;
    let clm = this.contentLayout.contentLayoutModules.find(x => x.contentModuleId == id);
    if (clm) {
      let isHidden = this.conditions[clm.contentLayoutModuleId]?.hidden;
      if (isHidden) {
        hidden = true;
      }
    }
    return hidden;
  };

  setVoucherList = list => {
    runInAction(() => {
      this.voucherList = list;
    });
  };

  setValidatePaymentFields = val => {
    runInAction(() => {
      this.validatePaymentFields = val;
    });
  };

  checkIsSurveyAnswered = async (layoutCode, badgeNo) => {
    if (layoutCode && badgeNo) {
      const { data } = await axiosClient.get(`./attendee/survey/${layoutCode}/${badgeNo}`);
      const { isAnswered, redirectCode } = data;
      if (isAnswered && redirectCode) {
        window.location.href = `${window.location.origin}${!window.location.href.includes('localhost') ? '/cms' : ''}/web/${redirectCode}${
          window.location.search
        }`;
      }
    }
  };

  checkEventAvailability = async (eventId, orderId, sqlStateNo, add = false) => {
    const count = (this.orders.filter(x => x.orderRow?.some(y => y.eventId === eventId))?.length ?? 0) + (add ? 1 : 0);
    const { data } = await axiosClient.get(
      `./attendee/status/${eventId}${orderId && orderId > 0 ? '/' + orderId : ''}?sqlStateNo=${sqlStateNo ? sqlStateNo : 0}&count=${count}`
    );
    return data.available;
  };

  updateSqlState = () => {
    let storageStates = localStorage.getItem('formstates');
    let formStates = undefined;

    if (storageStates) {
      formStates = JSON.parse(storageStates);
    } else {
      formStates = [];
    }
    var state = formStates.find(fs => fs.formId === this.contentLayout.contentLayoutId && fs.expires > Date.now());
    if (state) {
      state.expires = Date.now() + 1800000;
    } else {
      formStates.push({
        formId: this.contentLayout.contentLayoutId,
        sqlStateNo: this.sqlStateNo,
        expires: Date.now() + 1800000,
      });
    }

    formStates = formStates.filter(fs => fs.expires > Date.now());
    localStorage.setItem('formstates', JSON.stringify(formStates));

    const body = {
      eventId: this.environment.eventId,
      sqlStateNo: this.sqlStateNo,
      stateString: JSON.stringify(this.orders),
    };

    axiosClient.post(`./attendee/`, body, { responseType: 'json' });
  };

  updateOrder = (updatedOrder, personNo = this.activePersonNo) => {
    const nextOrder = {
      ...this.orders[personNo],
      ...updatedOrder,
      person: {
        ...(this.orders[personNo]?.person ?? {}),
        ...(updatedOrder?.person ?? {}),
      },
      orderExtra: [
        ...(this.orders[personNo]?.orderExtra ?? []),
        ...(updatedOrder?.orderExtra?.filter(item => !this.orders?.[personNo]?.orderExtra?.some(x => x.orderExtraId === item.orderExtraId)) ?? []),
      ],
    };

    nextOrder.sqlStateNo = this.sqlStateNo; // fix
    nextOrder.contentLayoutId = this.contentLayout.contentLayoutId;
    nextOrder.eventId = this.environment.eventId;
    nextOrder.languageCode = this.environment.lang;
    const exhibitorId = getUrlParam('exi');

    if (exhibitorId && !isNaN(exhibitorId)) {
      if (!nextOrder.orderExtra)
        nextOrder.orderExtra = [
          {
            orderExtraId: 0,
            name: 'ExhibitorInvite',
            value: `${exhibitorId}`,
            value2: '',
          },
        ];
      else if (!nextOrder.orderExtra.some(oe => oe.name == 'ExhibitorInvite')) {
        nextOrder.orderExtra.push({
          orderExtraId: 0,
          name: 'ExhibitorInvite',
          value: `${exhibitorId}`,
          value2: '',
        });
      } else if (nextOrder.orderExtra.find(oe => oe.name == 'ExhibitorInvite')) {
        nextOrder.orderExtra.find(oe => oe.name == 'ExhibitorInvite').value = `${exhibitorId}`;
      }
    }

    if (!nextOrder.orderRow) nextOrder.orderRow = [];
    if (!nextOrder?.orderRow?.some(row => row.eventId === this.environment.eventId)) {
      nextOrder.orderRow.push({
        amount: this.mainEvent.amount,
        comment: '',
        discount: 0,
        eventId: this.mainEvent.eventId,
        orderId: -1,
        orderRowId: nextOrder.orderRow.length * -1,
        quantity: 1,
        status: null,
        vatPercent: this.mainEvent.vatPercent,
        deleted: false,
      });
    }

    if (updateSqlStateTimeout) {
      clearTimeout(updateSqlStateTimeout);
    }

    updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);
    runInAction(() => {
      this.orders[personNo] = nextOrder;
      this.orders = [...this.orders];
    });
    const personTypeId = getUrlParam('pti');
    if (personTypeId && !isNaN(personTypeId)) {
      this.addPersonType(parseInt(personTypeId));
    }
  };

  createNewOrderRowId() {
    const nonCreatedOrderRows = this.orderRows?.filter(row => row.orderRowId < 0)?.map(row => row.orderRowId) ?? [];

    if (!nonCreatedOrderRows.length) return -1;

    const newOrderRowId = (Math.min(...nonCreatedOrderRows) ?? 0) - 1;
    return newOrderRowId;
  }

  updateOrderRow = (orderRow, forceUncheck = false, prechecked = null, displayYesNo = null) => {
    runInAction(() => {
      if (this.orders?.length === 0) {
        this.createOrder();
      }

      let order = this.orders[this.activePersonNo];

      if (orderRow?.orderId && order.orderId !== orderRow.orderId) {
        order = this.orders.find(o => o.orderId === orderRow.orderId);
      }

      if (!order.orderRow) {
        order.orderRow = [
          {
            amount: this.mainEvent.amount,
            comment: '',
            discount: 0,
            eventId: this.mainEvent.eventId,
            orderId: -1,
            orderRowId: this.createNewOrderRowId(),
            quantity: 1,
            status: null,
            vatPercent: this.mainEvent.vatPercent,
            deleted: false,
          },
        ];
      }

      if (orderRow?.eventId && !order.orderRow.find(or => or.eventId === orderRow?.eventId) && !forceUncheck) {
        order.orderRow.push(orderRow);
      } else if ((forceUncheck || (orderRow.deleted && orderRow?.eventId)) && orderRow.status !== 'Cancelled') {
        order.orderRow = order.orderRow.filter(or => or.eventId !== orderRow.eventId);
      } else if (!orderRow.hotelGroupId && !orderRow.hotelAllotmentPricingId) {
        order.orderRow = order.orderRow.map(or => {
          if (or.eventId == orderRow.eventId) {
            or = orderRow;
          }
          return or;
        });
      }

      if (orderRow?.eventId) {
        const index = order.orderRow.findIndex(or => or.eventId === orderRow.eventId && or.status !== orderRow.status && or.orderRowId);
        if (index !== -1) {
          order.orderRow[index].status = orderRow.status;
        }
      }

      if (orderRow.hotelGroupId && orderRow.hotelAllotmentPricingId) {
        if (orderRow.deleted) {
          order.orderRow = order.orderRow.filter(or => or.orderRowId !== orderRow.orderRowId);
        } else if (
          !order.orderRow.some(or => or.hotelGroupId === orderRow.hotelGroupId && or.hotelAllotmentPricingId === orderRow.hotelAllotmentPricingId) &&
          !orderRow.deleted
        ) {
          order.orderRow.push(orderRow);
        } else {
          const index = order.orderRow.findIndex(
            or =>
              (or.orderRowId === orderRow.orderRowId) &
              (or.hotelGroupId === orderRow.hotelGroupId) &
              (or.hotelAllotmentPricingId === orderRow.hotelAllotmentPricingId)
          );
          if (index !== -1) {
            order.orderRow[index] = orderRow;
          }
        }
      }

      if (!order.orderExtra) {
        order.orderExtra = [];
      }

      if (forceUncheck && displayYesNo && !order.orderExtra.find(oe => oe.name === 'EventRejected' && oe.value == orderRow.eventId)) {
        order.orderExtra.push({ name: 'EventRejected', value: orderRow.eventId, value2: '' });
      } else if (!forceUncheck && displayYesNo && order.orderExtra.find(oe => oe.name === 'EventRejected' && oe.value == orderRow.eventId)) {
        order.orderExtra = order.orderExtra.filter(oe => !(oe.name === 'EventRejected' && oe.value == orderRow.eventId));
      }

      if (updateSqlStateTimeout) {
        clearTimeout(updateSqlStateTimeout);
      }
      updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);

      if (order.orderId !== this.orders[this.activePersonNo].orderId) {
        this.orders[this.orders.findIndex(o => o.orderId === order.orderId)] = order;
      } else {
        this.orders[this.activePersonNo] = order;
      }

      this.orders = [...this.orders];
    });
  };

  removeOrder = index => {
    var newOrderList = Array.from(this.orders);
    var newActivePersonNo = 0;

    if (this.orders.length > 1) {
      const orderToRemove = newOrderList[index];
      const indexToRemove = newOrderList.indexOf(orderToRemove);
      if (indexToRemove != -1) {
        if (indexToRemove <= this.activePersonNo) {
          newActivePersonNo = this.activePersonNo - 1;
        }
        newOrderList.splice(index, 1);
      }
    }
    this.activePersonNo = newActivePersonNo;
    this.orders = newOrderList;
  };

  setActiveOrder = index => {
    runInAction(() => {
      this.activePersonNo = index;
      this.checkConditionsOld();
      this.checkConditions();
    });
  };

  setActivePage = int => {
    runInAction(() => {
      this.current.activePage = int;
      if (this.contentLayout?.activateGroupLeaderOnPage && this.contentLayout?.activateGroupLeaderOnPage == this.current?.activePage) {
        runInAction(() => {
          let leader = this.orders.find(x => x.leader);
          if (leader) {
            this.setActiveOrder(this.orders.indexOf(leader));
          }
        });
      }
    });
  };

  setLeader = index => {
    var newOrderList = Array.from(this.orders);
    newOrderList = newOrderList.map((n, i) => {
      runInAction(() => {
        n.leader = false;
        if (i == index) n.leader = true;
      });
      return n;
    });
    this.orders = newOrderList;
  };

  newOrderId = () => {
    const nonCreatedOrders = this.orders?.filter(({ orderId }) => orderId < 0)?.map(({ orderId }) => orderId) ?? [];

    if (!nonCreatedOrders.length) return -1;

    const newOrderId = (Math.min(...nonCreatedOrders) ?? 0) - 1;
    return newOrderId;
  };

  createOrder = () => {
    const newOrder = {};
    newOrder.sqlStateNo = this.sqlStateNo; // fix
    newOrder.contentLayoutId = this.contentLayout.contentLayoutId;
    newOrder.eventId = this.contentLayout.eventId;
    newOrder.languageCode = this.environment.lang;
    newOrder.orderId = this.newOrderId();

    if (this.orders.length > 0) {
      newOrder.leader = false;
      newOrder.orderId = this.newOrderId();
    } else {
      newOrder.leader = true;
    }

    const exhibitorId = getUrlParam('exi');

    if (exhibitorId && !isNaN(exhibitorId)) {
      newOrder.orderExtra = [
        {
          orderExtraId: 0,
          name: 'ExhibitorInvite',
          value: `${exhibitorId}`,
          value2: '',
        },
      ];
    }

    if (!newOrder.orderRow) {
      newOrder.orderRow = [];
    }

    if (!newOrder.orderRow.find(row => row.eventId === this.mainEvent.eventId)) {
      newOrder.orderRow.push({
        amount: this.mainEvent.amount,
        comment: '',
        discount: 0,
        eventId: this.mainEvent.eventId,
        orderId: newOrder.orderId,
        orderRowId: newOrder.orderRow.length * -1,
        quantity: 1,
        status: null,
        vatPercent: this.mainEvent.vatPercent,
        deleted: false,
      });
    }
    if (updateSqlStateTimeout) {
      clearTimeout(updateSqlStateTimeout);
    }

    updateSqlStateTimeout = setTimeout(this.updateSqlState, 500);
    if (this.orders.length > 0 && toJS(this.orders)[this.activePersonNo]) {
      this.checkForGroupTransferValues(this.orders[this.activePersonNo], newOrder);
    }

    this.orders.push(newOrder);
    this.configureValidation();

    this.activePersonNo = this.orders.length > 0 ? this.orders.length - 1 : 0;

    const personTypeId = getUrlParam('pti');
    if (personTypeId && !isNaN(personTypeId)) {
      newOrder.personTypes = [{ orderId: 0, personTypeId: parseInt(personTypeId) }];
    }
    this.checkConditionsOld();
    this.checkConditions();
  };

  addPersonType = personTypeId => {
    runInAction(() => {
      if (!this.orders[this.activePersonNo].personTypes) {
        this.orders[this.activePersonNo].personTypes = [];
      }
      if (!this.orders[this.activePersonNo].personTypes.find(pt => pt.personTypeId === personTypeId)) {
        this.orders[this.activePersonNo].personTypes.push({
          orderId: 0,
          personTypeId,
        });
        this.orders[this.activePersonNo] = {
          ...this.orders[this.activePersonNo],
        };
        this.orders = [...this.orders];
      }
    });
  };

  removePersonType = personTypeId => {
    if (this.orders?.[this.activePersonNo]?.personTypes) {
      runInAction(() => {
        this.orders[this.activePersonNo].personTypes = this.orders[this.activePersonNo].personTypes.filter(
          pt => pt.personTypeId !== personTypeId && !pt.personTypeOrderId
        );
        this.orders = [...this.orders];
      });
    }
  };

  setWebConfirmation = webConfirmationId => {
    if (this.orders[this.activePersonNo]) {
      runInAction(() => {
        this.orders[this.activePersonNo].webConfirmationId = webConfirmationId;
        this.orders[this.activePersonNo] = {
          ...this.orders[this.activePersonNo],
        };
        this.orders = [...this.orders];
      });
    }
  };

  setSmsConfirmation = smsConfirmationId => {
    if (this.orders[this.activePersonNo]) {
      runInAction(() => {
        this.orders[this.activePersonNo].smsConfirmationId = smsConfirmationId;
        this.orders[this.activePersonNo] = {
          ...this.orders[this.activePersonNo],
        };
        this.orders = [...this.orders];
      });
    }
  };

  setEmailConfirmation = comContentId => {
    if (this.orders[this.activePersonNo]) {
      runInAction(() => {
        this.orders[this.activePersonNo].emailConfirmationId = comContentId;
        this.orders[this.activePersonNo] = {
          ...this.orders[this.activePersonNo],
        };
        this.orders = [...this.orders];
      });
    }
  };

  setSecondaryEmailConfirmation = comContentId => {
    if (this.orders[this.activePersonNo]) {
      runInAction(() => {
        this.orders[this.activePersonNo].secondaryEmailConfirmationId = comContentId;
        this.orders[this.activePersonNo] = {
          ...this.orders[this.activePersonNo],
        };
        this.orders = [...this.orders];
      });
    }
  };
  checkForGroupTransferValues(previousOrder, newOrder) {
    if (this.questions.length > 0) {
      this.modules.map(m => {
        if (m.settings?.groupTransfer) {
          if (m.type === 'FIELD') {
            const field = this.fields.find(f => f.fieldId == m.settings.fieldId);
            if (previousOrder[_.camelCase(field.type)]?.[_.camelCase(field.name)]) {
              if (!newOrder[_.camelCase(field.type)]) {
                newOrder[[_.camelCase(field.type)]] = {};
              }
              newOrder[[_.camelCase(field.type)]][_.camelCase(field.name)] = previousOrder[_.camelCase(field.type)][_.camelCase(field.name)];
            }
          } else if (m.type === 'EVENT') {
            let row = previousOrder?.orderRow?.find(or => or.eventId == m.settings.eventId);
            if (row) {
              if (!newOrder.orderRow) {
                newOrder.orderRow = [];
              }
              newOrder.orderRow.push({
                ...row,
                orderId: newOrder.orderId,
                orderRowId: newOrder.orderRow.length * -1,
              });
            }
          } else if (m.type === 'QUESTION') {
            const answer = previousOrder?.answer?.find(a => a.questionId == m.settings.questionId);
            if (answer) {
              if (!newOrder.answer) {
                newOrder.answer = [];
              }
              newOrder.answer.push({
                answerId: 0,
                interactionKey: null,
                orderId: 0,
                questionId: m.settings.questionId,
                answerRow: answer.answerRow?.map(ar => {
                  return {
                    answerId: 0,
                    answerRowId: 0,
                    questionOptionId: ar.questionOptionId,
                    text: ar.text,
                    deleted: false,
                  };
                }),
              });
            }
          }
        }
      });
    }
  }

  updateEventLabels = (groupName, groupData = {}) => {
    runInAction(() => {
      this.eventLabels = { ...this.eventLabels, [groupName]: groupData };
    });
  };

  triggerValidation = (trigger = true) => {
    runInAction(() => {
      this.validate = trigger;
    });
  };

  register = callback => {
    let isValid = this.validations.filter(v => v.valid == false && !this.isHiddenByConditions(v.id) && !v.hidden)?.length === 0;
    if (this.current.payMethod == 'dibs' || this.current.payMethod === 'stripe')
      isValid = this.getFilteredValidations().filter(v => v.valid == false).length == 0;
    isValid = this.checkInvoiceValidation(isValid);

    if (isValid) {
      let orders = Array.from(this.orders);
      if (this.current.payMethod) {
        orders.map(o => {
          o.payMethod = this.current.payMethod;
          o.contentLayoutId = this.contentLayout.contentLayoutId;
          if (!o.webConfirmationId) o.webConfirmationId = this.contentLayout.webConfirmation;
          if (!o.emailConfirmationId) o.emailConfirmationId = this.contentLayout.emailConfirmation;
          if (!o.smsConfirmationId) o.smsConfirmationId = this.contentLayout.smsConfirmation;
          if (!o.secondaryEmailConfirmationId) o.secondaryEmailConfirmationId = this.contentLayout.secondaryEmailConfirmation;
        });
      } else {
        orders.map(o => {
          o.contentLayoutId = this.contentLayout.contentLayoutId;
          if (!o.webConfirmationId) o.webConfirmationId = this.contentLayout.webConfirmation;
          if (!o.emailConfirmationId) o.emailConfirmationId = this.contentLayout.emailConfirmation;
          if (!o.smsConfirmationId) o.smsConfirmationId = this.contentLayout.smsConfirmation;
          if (!o.secondaryEmailConfirmationId) o.secondaryEmailConfirmationId = this.contentLayout.secondaryEmailConfirmation;
        });
      }

      const dto = [];

      orders.forEach(o => {
        const order = {
          orderId: o.orderId ? o.orderId : null,
          eventIds: [],
        };

        if (o.orderRow) {
          o.orderRow
            .filter(({ orderRowId, status }) => orderRowId < 0 && status !== 'Waitlist')
            .forEach(or => {
              order.eventIds.push(or.eventId);
            });
        }
        if (!order.discounts) {
          order.discounts = [];
        }
        if (order.eventIds.length > 0) {
          dto.push(order);
        }
      });

      if (dto.length > 0) {
        axiosClient.post(`./attendee/statusrange/${this.sqlStateNo}`, dto).then(({ data }) => {
          if (data.available) {
            if (this.contentLayout.type === 'SURVEY') this.surveyPost(orders, callback);
            else this.formPost(orders, callback);
          } else {
            alert('OrderRowFull');
          }
        });
      } else {
        if (this.contentLayout.type === 'SURVEY') this.surveyPost(orders, callback);
        else this.formPost(orders, callback);
      }
    }
  };

  surveyPost = (orders, callback) => {
    axiosClient
      .post(`./cms/postSurvey/`, orders)
      .then(({ data }) => {
        let item = localStorage.getItem('formstates');
        if (item) {
          let states = JSON.parse(item);
          let prevState = states.find(s => s.formId === this.contentLayout.contentLayoutId && s.expires > Date.now());
          if (prevState) {
            states.splice(states.indexOf(prevState), 1);
            localStorage.setItem('formstates', JSON.stringify(states));
          }
        }
        if (localStorage.getItem('9983memberCache')) localStorage.removeItem('9983memberCache');
        window.location.href = window.location.origin + (!window.location.href.includes('localhost') ? '/cview' : '') + data.redirectUrl;
      })
      .catch(err => {
        if (typeof callback === 'function') {
          callback(false);
        }
        this.globalAlert = 'RegisterFailed';
      });
  };

  showQuestionModule = id => {
    let foundModule = true;
    let specificModule = this.contentLayout.contentLayoutModules.find(x => x.contentModule.type == 'QUESTION' && x.contentModule.settings.questionId == id);
    if (specificModule) {
      let isHidden = this.conditions[specificModule.contentLayoutModuleId]?.hidden;
      if (isHidden) {
        foundModule = false;
      }
    }
    return foundModule;
  };

  formPost = (orders, callback) => {
    orders = _.cloneDeep(orders);
    //exclude hidden required questions
    orders.forEach(order => {
      if (order && order?.person && typeof order.person === 'object') {
        order.person = Object.entries(order.person).reduce((acc, key) => {
          acc[key[0]] = key?.[1] && typeof key?.[1] === 'string' ? key?.[1]?.trim() : key?.[1];
          return acc;
        }, {});
      }

      if (order.answer && order.answer.length > 0) {
        order.answer.forEach(question => {
          let include = this.showQuestionModule(question.questionId);
          if (!include) {
            order.answer = order.answer.filter(x => x.questionId != question.questionId);
          }
        });
      }
    });

    axiosClient
      .post(`./cms/post/`, orders)
      .then(({ data }) => {
        let item = localStorage.getItem('formstates');
        if (item) {
          let states = JSON.parse(item);
          let prevState = states.find(s => s.formId === this.contentLayout.contentLayoutId && s.expires > Date.now());
          if (prevState) {
            states.splice(states.indexOf(prevState), 1);
            localStorage.setItem('formstates', JSON.stringify(states));
          }
        }
        if (localStorage.getItem('9983memberCache')) localStorage.removeItem('9983memberCache');
        const searchParams = new URLSearchParams(window.location.search);
        const station = searchParams.get('station');
        window.location.href =
          window.location.origin + (!window.location.href.includes('localhost') ? '/cms' : '') + data.redirectUrl + (station ? '&station=' + station : '');
      })
      .catch(err => {
        if (typeof callback === 'function') {
          callback(false);
        }
        this.globalAlert = 'RegisterFailed';
      });
  };

  checkConditions = sourceKey => {
    let targets = [];
    if (this.contentLayout.contentLayoutModules.length > 0) {
      this.contentLayout.contentLayoutModules.forEach(clm => {
        if (Array.isArray(clm.conditions) && (!sourceKey || clm.conditions.some(c => c.sourceKey === sourceKey))) {
          targets.push(clm);
        }
      });
    }
    if (Array.isArray(this.contentLayout.conditions) && (!sourceKey || this.contentLayout.conditions.some(c => c.sourceKey === sourceKey))) {
      targets.push(this.contentLayout);
    }
    targets.forEach(async target => {
      await this.resolveQuery(target);
    });
  };
  checkConditionsOld = contentLayoutModuleId => {
    let targets = [];
    if (this.contentLayout.contentLayoutModules.length > 0) {
      this.contentLayout.contentLayoutModules.map(clm => {
        if (
          Array.isArray(clm.conditions) &&
          ((!contentLayoutModuleId && clm.conditions.some(c => c.sourceId > 0)) ||
            clm.conditions.some(c => c.sourceId == contentLayoutModuleId) ||
            clm.contentLayoutModuleId == contentLayoutModuleId)
        ) {
          targets.push(clm);
        }
      });
    }
    if (
      Array.isArray(this.contentLayout.conditions) &&
      (!contentLayoutModuleId || this.contentLayout.conditions.some(c => c.sourceId == contentLayoutModuleId))
    ) {
      targets.push(this.contentLayout);
    }
    if (this.environment.eventId === 9983) {
      targets.forEach(async target => {
        await this.customResolveQuery(target);
      });
    } else {
      targets.forEach(async target => {
        this.resolveQuery(target);
      });
    }
  };
  resolveQuery = async target => {
    //ALla conditions för det här target elementet
    //filtrerar alla conditons som inte är i grupp 0

    // let queryStr = "";
    let conditionLists = {};

    for (const action in conditionConstants.actions) {
      if (conditionConstants.actions.hasOwnProperty(action)) {
        conditionLists[conditionConstants.actions[action]] = target.conditions.filter(el => el.action == conditionConstants.actions[action]);
      }
    }
    for (const action in conditionLists) {
      if (conditionLists.hasOwnProperty(action)) {
        if (conditionLists[action] && conditionLists[action].length > 0) {
          const secondaryActions = [
            ...new Set(
              conditionLists[action].map(c => {
                return c.secondaryAction;
              })
            ),
          ];
          for (const secondaryAction of secondaryActions) {
            let queryStr = '';
            const conditionsToProcess = conditionLists[action]
              .filter(c => c.secondaryAction === secondaryAction)
              .sort((a, b) => {
                return a.sortOrder - b.sortOrder;
              });
            for (const c of conditionsToProcess) {
              if (c.prefix) queryStr += ' ' + c.prefix.replace('AND', '&&').replace('OR', '||') + ' ';
              queryStr += c.sourceId ? this.resolveConditionOld(c) : await this.resolveCondition(c);
              if (c.suffix) queryStr += ' ' + c.suffix.replace('AND', '&&').replace('OR', '||') + ' ';
            }
            try {
              let result = eval(queryStr);
              this.executeAction(action, secondaryAction, target.contentLayoutModuleId, result);
            } catch (err) {
              console.error(`Invalid Condition in {${target.contentModule?.type}} module: #${target.contentModule?.cssId}`, err);
            }
          }
        }
      }
    }
  };
  customResolveQuery = async target => {
    let conditionLists = {};

    for (const action in conditionConstants.actions) {
      if (conditionConstants.actions.hasOwnProperty(action)) {
        conditionLists[conditionConstants.actions[action]] = target.conditions.filter(el => el.action == conditionConstants.actions[action]);
      }
    }

    for (const action in conditionLists) {
      if (conditionLists.hasOwnProperty(action)) {
        if (conditionLists[action] && conditionLists[action].length > 0) {
          const secondaryActions = [
            ...new Set(
              conditionLists[action].map(c => {
                return c.secondaryAction;
              })
            ),
          ];
          for (const secondaryAction of secondaryActions) {
            let queryStr = '';
            const queryList = conditionLists[action]
              .filter(c => c.secondaryAction === secondaryAction)
              .sort((a, b) => {
                return a.sortOrder - b.sortOrder;
              });

            for (const c of queryList) {
              const source = this.extractElement(c.sourceId);
              const sourceValue = conditionNavigator.navigate(source, this.orders, this.activePersonNo);

              if (c.prefix) queryStr += ' ' + c.prefix.replace('AND', '&&').replace('OR', '||') + ' ';
              if (
                source?.contentModule.type === 'FIELD' &&
                source?.contentModule?.settings?.fieldType === 'OrgNo' &&
                c.operator === 'LIKE' &&
                sourceValue &&
                validateOrgno(sourceValue, 'SWE')
              ) {
                if (cache[sourceValue] !== null && cache[sourceValue] !== undefined) {
                  if (c.value === 'member_lookup_true') {
                    queryStr = cache[sourceValue] ? `('true' == 'true')` : `('false' == 'true')`;
                  }

                  if (c.value === 'member_lookup_false') {
                    queryStr = !cache[sourceValue] ? `('true' == 'true')` : `('false' == 'true')`;
                  }
                } else {
                  try {
                    const response = await basedAxios.get(`./utility/member/${sourceValue}`);
                    const isMember = response.data;

                    cache[sourceValue] = isMember;

                    if (c.value === 'member_lookup_true') {
                      queryStr = isMember ? `('true' == 'true')` : `('false' == 'true')`;
                    }

                    if (c.value === 'member_lookup_false') {
                      queryStr = !isMember ? `('true' == 'true')` : `('false' == 'true')`;
                    }
                  } catch (error) {
                    queryStr = `('false' == 'true')`;
                  }
                }
              } else {
                queryStr += this.resolveCondition(c);
              }
              if (c.suffix) queryStr += ' ' + c.suffix.replace('AND', '&&').replace('OR', '||') + ' ';
            }

            try {
              let result = eval(queryStr);
              this.executeAction(action, secondaryAction, target.contentLayoutModuleId, result);
            } catch (err) {
              console.error(`Invalid Condition in {${target.contentModule?.type}} module: #${target.contentModule?.cssId}`, err);
            }
          }
        }
      }
    }
  };
  resolveCondition = async condition => {
    const paramNames = condition.sourceKey.split('.');
    const sourceValue = conditionNavigator.navigate(condition.sourceKey, this.orders, this.activePersonNo, this.environment);
    if (paramNames[0] === 'EVENT' && condition.operator === 'FULL') {
      if (this.breakoutsFullbooked[paramNames[1]]) {
        return `('true' == 'true')`;
      } else {
        return `('false' == 'true')`;
      }
    } else if (paramNames[0] === 'EVENT' && condition.operator === 'NOT_FULL') {
      if (this.breakoutsFullbooked[paramNames[1]]) {
        return `('false' == 'true')`;
      } else {
        return `('true' == 'true')`;
      }
    } else if (paramNames[0] === 'EVENT' && condition.operator === 'VOUCHER_FULL') {
      if (this.voucherFullbooked[paramNames[1]]) {
        return `('true' == 'true')`;
      } else {
        return `('false' == 'true')`;
      }
    } else if (
      this.environment.eventId === 9983 &&
      paramNames[1] === 'OrgNo' &&
      condition.operator === 'LIKE' &&
      sourceValue &&
      validateOrgno(sourceValue, 'SWE')
    ) {
      const cache = localStorage.getItem('9983memberCache') ? JSON.parse(localStorage.getItem('9983memberCache')) : {};
      if (cache[sourceValue] !== null && cache[sourceValue] !== undefined) {
        return `('${cache[sourceValue]}' == '${condition.value === 'member_lookup_true'}')`;
      } else {
        try {
          const response = await basedAxios.get(`./utility/member/${sourceValue}`);
          const isMember = response.data;
          cache[sourceValue] = isMember;
          localStorage.setItem('9983memberCache', JSON.stringify(cache));
          return `('${cache[sourceValue]}' == '${condition.value === 'member_lookup_true'}')`;
        } catch (error) {
          return `('false' == 'true')`;
        }
      }
    } else if (Array.isArray(sourceValue) || condition.operator === conditionConstants.operators.LIKE) {
      return this.resolveCheckboxCondition(sourceValue, condition);
    } else {
      if (condition.operator.includes('GREATER') || condition.operator.includes('LESS')) {
        return `(${sourceValue?.length ?? 0} ${conditionTranslator.translateOperator(condition.operator)} ${condition.value})`;
      } else if (condition.operator.includes('ANY')) {
        return `(${sourceValue?.length ?? 0} > 0)`;
      } else {
        return `('${sourceValue}' ${conditionTranslator.translateOperator(condition.operator)} '${condition.value}')`;
      }
    }
  };
  resolveConditionOld = condition => {
    const source = this.extractElement(condition.sourceId);
    let conditionStr = '';

    if (source) {
      const sourceValue = conditionNavigator.navigateOld(source, this.orders, this.activePersonNo, this.environment);
      if (source.contentModule.type === 'EVENT' && condition.operator === 'FULL') {
        if (this.breakoutsFullbooked[source.contentModule.settings.eventId]) {
          conditionStr = `('true' == 'true')`;
        } else {
          conditionStr = `('false' == 'true')`;
        }
      } else if (source.contentModule.type === 'EVENT' && condition.operator === 'NOT_FULL') {
        if (this.breakoutsFullbooked[source.contentModule.settings.eventId]) {
          conditionStr = `('false' == 'true')`;
        } else {
          conditionStr = `('true' == 'true')`;
        }
      } else if (source.contentModule.type === 'EVENT' && condition.operator === 'VOUCHER_FULL') {
        if (this.voucherFullbooked[source.contentModule.settings.eventId]) {
          conditionStr = `('true' == 'true')`;
        } else {
          conditionStr = `('false' == 'true')`;
        }
      } else if (Array.isArray(sourceValue) || condition.operator === conditionConstants.operators.LIKE) {
        conditionStr = this.resolveCheckboxCondition(sourceValue, condition);
      } else {
        if ((condition.operator.includes('GREATER') || condition.operator.includes('LESS')) && sourceValue) {
          conditionStr = `(${sourceValue.length} ${conditionTranslator.translateOperator(condition.operator)} ${condition.value})`;
        } else if (condition.operator.includes('ANY')) {
          conditionStr = `(${sourceValue?.length ?? 0} > 0)`;
        } else {
          conditionStr = `('${sourceValue}' ${conditionTranslator.translateOperator(condition.operator)} '${condition.value}')`;
        }
      }
    }
    return conditionStr;
  };

  resolveCheckboxCondition = (sourceValue, condition) => {
    let cStr = '';
    if (condition.operator == conditionConstants.operators.ANY && sourceValue.length > 0) {
      cStr = '(true)';
    } else if (condition.operator == conditionConstants.operators.LIKE && sourceValue && sourceValue.toString().includes(condition.value)) {
      cStr = '(true)';
    } else if (condition.operator == conditionConstants.operators.EQUAL) {
      cStr = `(${sourceValue.some(sv => sv == condition.value)})`;
    } else if (condition.operator == conditionConstants.operators.NOT_EQUAL) {
      cStr = `(${!sourceValue.some(sv => sv == condition.value)})`;
    } else if (condition.operator == conditionConstants.operators.LESS_THAN_OR_EQUAL_TO) {
      cStr = `(${sourceValue.length <= condition.value})`;
    } else if (condition.operator == conditionConstants.operators.GREATER_THAN_OR_EQUAL_TO) {
      cStr = `(${sourceValue.length >= condition.value})`;
    } else {
      cStr = '(false)';
    }
    return cStr;
  };

  executeAction = (action, secondaryAction, id, value) => {
    if (action === 'persontype') {
      if (value) {
        this.addPersonType(parseInt(secondaryAction.replace('persontype', '').replace('pt', '')));
      } else {
        this.removePersonType(parseInt(secondaryAction.replace('persontype', '').replace('pt', '')));
      }
    } else if (action === 'webconf') {
      if (value) this.setWebConfirmation(parseInt(secondaryAction.replace('webconf', '')));
    } else if (action === 'emailconf') {
      if (value) this.setEmailConfirmation(parseInt(secondaryAction.replace('emailconf', '')));
    } else if (action === 'groupemailconf') {
      if (value) this.setSecondaryEmailConfirmation(parseInt(secondaryAction.replace('groupemailconf', '')));
    } else {
      runInAction(() => {
        if (!this.conditions[id])
          this.conditions[id] = {
            hidden: false,
            readonly: false,
            required: false,
          };
        switch (action) {
          case conditionConstants.actions.hidden:
            this.conditions[id].hidden = !value;
            break;
          case conditionConstants.actions.required:
            this.conditions[id].required = value;
            break;
          case conditionConstants.actions.readonly:
            this.conditions[id].readonly = value;
          case conditionConstants.actions.CustomError:
            break;
          default:
            break;
        }
      });
    }
  };

  extractElement = id => {
    if (isNaN(id) && id.startsWith('LANGUAGE')) {
      return { contentModule: { type: 'LANGUAGE' }, contentLayoutModuleId: 'LANGUAGE' };
    }

    if (isNaN(id) && id.startsWith('MEETING')) {
      return { contentModule: { type: 'MEETING' }, contentLayoutModuleId: 'MEETING' };
    }

    const source = this.contentLayout.contentLayoutModules.find(clm => {
      return clm.contentLayoutModuleId === id;
    });
    return source;
  };

  setBreakoutFullbooked = (eventId, bookedStatus) => {
    runInAction(() => {
      this.breakoutsFullbooked[eventId] = bookedStatus;
    });
    this.checkConditionsOld();
    this.checkConditions();
  };

  setVoucherFullbooked = (eventId, bookedStatus) => {
    runInAction(() => {
      this.voucherFullbooked[eventId] = bookedStatus;
    });
    this.checkConditionsOld();
    this.checkConditions();
  };
}

// Bare store
export const timerStore = new ContentViewStore();
// Store as React context
export const useStore = () => timerStore;

// This makes the timer go
